const mediaItems = [
  {
    title: '《暗夜追凶》幕后特辑',
    desc: '独家探班，导演讲述拍摄背后的故事',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20behind%20the%20scenes%20director%20working%20on%20set%20with%20camera%2C%20dark%20moody%20lighting%2C%20warm%20red%20and%20gold%20accents%2C%20cinematic%20film%20production%20atmosphere%2C%20professional%20film%20crew&width=800&height=500&seq=media-01&orientation=landscape',
    duration: '15:32',
  },
  {
    title: '国产科幻电影十年回顾',
    desc: '从模仿到创新，中国科幻的崛起之路',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20retrospective%20montage%20spaceship%20and%20futuristic%20scenes%2C%20warm%20golden%20red%20color%20palette%2C%20cinematic%20compilation%20aesthetic%2C%20film%20reel%20texture%20overlay&width=800&height=500&seq=media-02&orientation=landscape',
    duration: '22:10',
  },
  {
    title: '2026暑期档国产电影前瞻',
    desc: '暑期档最值得期待的国产大片一览',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20summer%20movie%20season%20promotional%20poster%20style%2C%20multiple%20film%20scenes%20collage%2C%20warm%20vibrant%20colors%20red%20gold%2C%20cinematic%20theater%20marquee%20with%20lights%2C%20festive%20atmosphere&width=800&height=500&seq=media-03&orientation=landscape',
    duration: '18:45',
  },
  {
    title: '影评人对谈：什么是好电影',
    desc: '三位资深影评人深度对话国产电影创作',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20film%20critics%20roundtable%20discussion%20in%20cozy%20studio%2C%20warm%20lighting%2C%20movie%20posters%20on%20background%20wall%2C%20professional%20broadcast%20setting%2C%20intellectual%20atmosphere%20red%20gold%20accents&width=800&height=500&seq=media-04&orientation=landscape',
    duration: '35:20',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            精彩内容
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            幕后故事、影评对谈、专题盘点，更多电影相关内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-40 md:h-44 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/30 transition-colors"></div>
                <div className="absolute bottom-2 right-2 flex items-center gap-1 px-2 py-1 bg-background-950/70 rounded-md">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xs"></i>
                  </span>
                  <span className="text-xs text-background-50 font-medium">{item.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}